import React from 'react';

import { schemas } from '@recurrency/core-api-schema';
import { McpAccessTokenDTO } from '@recurrency/core-api-schema/dist/users/mcpAccessTokens';
import { Typography } from 'antd';

import { Container } from 'components/Container';
import { CenteredError } from 'components/Loaders';
import { PageHeader } from 'components/PageHeader';
import { McpSessionsTable } from 'components/recipes/McpSessionsTable';

import { useCoreApi } from 'hooks/useApi';
import { useGlobalApp } from 'hooks/useGlobalApp';

import { coreApiFetch } from 'utils/api';

export const TenantMcpSessionsPage = () => {
  const { activeTenant } = useGlobalApp();
  const {
    data: sessionsData,
    error: sessionsError,
    isLoading: sessionsLoading,
    reload,
  } = useCoreApi(schemas.tenants.listTenantMcpAccessTokens, {
    pathParams: { tenantId: activeTenant.id },
    queryParams: {},
  });
  const {
    data: usersData,
    error: usersError,
    isLoading: usersLoading,
  } = useCoreApi(schemas.tenants.getTenantUsers, {
    pathParams: { tenantId: activeTenant.id },
  });

  const emailByUserId = new Map(
    (usersData?.items ?? []).map((tenantUser) => [tenantUser.userId, tenantUser.user.email]),
  );

  const onRevoke = async (token: McpAccessTokenDTO) => {
    await coreApiFetch(schemas.tenants.revokeTenantMcpAccessToken, {
      pathParams: { tenantId: activeTenant.id, jti: token.jti },
    });
    reload();
  };

  const error = sessionsError || usersError;
  if (error) {
    return <CenteredError error={error} />;
  }

  return (
    <Container>
      <PageHeader title="MCP Sessions" />
      <Typography.Paragraph type="secondary">
        Active MCP client sessions for this tenant. Revoking a session forces the client to reconnect.
      </Typography.Paragraph>
      <McpSessionsTable
        items={sessionsData?.items ?? []}
        isLoading={sessionsLoading || usersLoading}
        resolveUserEmail={(userId) => emailByUserId.get(userId) ?? userId}
        onRevoke={onRevoke}
      />
    </Container>
  );
};
